/** Turn the editor shell into a data URL on an opaque origin. */
export const toEditorSandboxDataUrl = (shell: string, parentOrigin: string, editorId: string): string => {
  const boot = JSON.stringify({ parentOrigin, editorId }).replace(/</g, "\\u003c");
  const withBoot = shell.replace("<head>", `<head><script>window.__sbcmsEditor=${boot};</script>`);
  const absolute = withBoot.replace(/(\s(?:src|href)=["'])\/(?!\/)/g, `$1${parentOrigin}/`);
  return `data:text/html;charset=utf-8,${encodeURIComponent(absolute)}`;
};

/**
 * The deployed host redirects editor-sandbox.html onto the admin app.
 * The shell is therefore embedded here, with the HugeRTE skin inlined.
 * A link to that skin would be a cross-origin stylesheet from the data document.
 */
export const buildEditorSandboxDocument = (
  shell: string,
  skinCss: string,
  parentOrigin: string,
  editorId: string
): string => {
  const safeSkin = skinCss.replace(/<\/style/gi, "<\\/style");
  const withSkin = shell.replace(
    "<head>",
    `<head><style id="sbcms-hugerte-skin">${safeSkin}</style>`
  );
  return toEditorSandboxDataUrl(withSkin, parentOrigin, editorId);
};
